import { WorkList } from './WorkList.js';
import { PatientDobChangeWarningMixin } from '../Mixins/PatientDobChangeWarningMixin.js';

export class SubmitCase extends PatientDobChangeWarningMixin(HTMLElement)
{
    constructor ()
    {
        super();
        const url = window.location.href;
        if (url.indexOf('id=') > -1 || url.indexOf('feedback') > -1) {
            this.worklist = new WorkList();
        }
    }

    connectedCallback()
    {
        super.connectedCallback();
        if (this.worklist) {
            this.worklist.connectedCallback();
        }
        this.init();
    }

    init ()
    {
        const _self = this;

        const genderSelectorElem = document.querySelector('select[name=gender]');
        const unknownOption = genderSelectorElem.querySelector('option[value="4"]');
        unknownOption.disabled = true;
        if (genderSelectorElem.value === "4") {
            genderSelectorElem.setCustomValidity('Undefined is not a valid option');
        }

        const speciesElem = document.querySelector('input[name=Species]');
        speciesElem.required = true;
        speciesElem.setAttribute('pattern', '(?!(o|O)(t|T)(h|H)(e|E)(r|R))[a-z\\-A-Z0-9]+');

        const breedElement = document.querySelector('input[name=Breed]');
        breedElement.required = true;
        breedElement.setAttribute('pattern', '(?!(o|O)(t|T)(h|H)(e|E)(r|R))[a-z\\-A-Z0-9]+');

        this.checkForResubmit();

        _self.initEventHandlers();
    }

    resubGroup(resubGroupID)
    {
        // now need to set the consultant group.
        const consultantGroupSelector = document.querySelector('.c_d_r_map_consultant_group');
        const currentOption = consultantGroupSelector.querySelector('option[selected');
        if (consultantGroupSelector.value != resubGroupID) {
            const resubGroupOption = consultantGroupSelector.querySelector('option[value="' + resubGroupID + '"]');
            if (resubGroupOption) {
                if (currentOption) {
                    currentOption.removeAttribute('selected');
                }
                resubGroupOption.setAttribute('selected', 'selected');
                consultantGroupSelector.value = resubGroupID;
                $(consultantGroupSelector).trigger('change');
            }
        }
    }

    resubPriority(resubPriorityID)
    {
        const prioritySelector = document.querySelector('select.priorityTypes');
        const currentOption = prioritySelector.querySelector('option[selected]');
        if (prioritySelector.value != resubPriorityID) {
            const resubPriorityOption = prioritySelector.querySelector('option[value="' + resubPriorityID + '"]');
            if (resubPriorityOption) {
                if (currentOption) {
                    currentOption.removeAttribute('selected');
                }
                resubPriorityOption.setAttribute('selected', 'selected');
                prioritySelector.value = resubPriorityID;
                $(prioritySelector).trigger('change');
            }
        }
    }



    checkForResubmit()
    {
        const resubmitInput = this.querySelector('input[name=reSubmit]');
        if (resubmitInput.value == 0) {
            return;
        }

        const resubClinicInput = this.querySelector('input[name=prev_clinic_id]');
        let resubClinicID = resubClinicInput.value;

        const resubGroupInput = this.querySelector('input[name=prev_rad_group_id]');
        const resubGroupID = resubGroupInput.value;

        const resubPriorityInput = this.querySelector('input[name=prev_priority]');
        const resubPriorityID = resubPriorityInput.value;

        // check if selected Clinic is the clinic from prev_submission
        const clinicSelector = document.querySelector('.c_d_r_map_clinic');
        if (clinicSelector.value != resubClinicID) {
            const currentOption = clinicSelector.querySelector('option[selected]');
            if (currentOption && currentOption.value != resubClinicID) {
                const resubClinicOption = clinicSelector.querySelector('option[value="' + resubClinicID + '"]');
                if (resubClinicOption) {
                    if (currentOption) {
                        currentOption.removeAttribute('selected');
                    }
                    resubClinicOption.setAttribute('selected', 'selected');
                    clinicSelector.value = resubClinicID;
                    setTimeout(() => {
                        $(clinicSelector).trigger('change');
                     }, 100);
                }
            }
        }

        if(resubGroupID > 0) {
            setTimeout(() => this.resubGroup(resubGroupID), 100);
        }

        if (resubPriorityID > 0) {
            setTimeout(() => this.resubPriority(resubPriorityID), 100);
        }
    }

    initEventHandlers ()
    {
        const _self = this

        _self.onGenderChange = _self.onGenderChange.bind(_self);
        const genderSelectorElem = document.querySelector('select[name=gender]');
        genderSelectorElem.addEventListener('change', _self.onGenderChange);

        const closeLevelBtn = this.querySelector('.closeLevel');
        closeLevelBtn.addEventListener('click', event => {
            event.preventDefault();
            history.back();
        });

        this.onReturnToUrl = this.onReturnToUrl.bind(this);
        document.addEventListener('return-url-event', this.onReturnToUrl);

    }

     onGenderChange(event)
    {
        event.stopPropagation();

        if (event.target.value === "4") {
            event.target.setCustomValidity('Undefined is not a valid option');
        } else {
            event.target.setCustomValidity('');
        }
    }

    onReturnToUrl(event)
    {
        console.log('%c event', "color:orange");
        if (event.detail.originalEvent) {
            const returnUrl = event.detail.returnUrl || false;
            if (returnUrl) {
                let message = 'Successfully saved case submission.  ';
                if (event.detail.originalEvent.classList.contains('submit-for-review')) {
                    message = 'Successfully submitted case for review.  ';
                }
                toastr.success(message + 'Redirecting you back to your referring page', 'Success', {
                    onHidden: () => {
                        const searchParams = new URLSearchParams({
                            success: true,
                            message: message
                        });
                        document.location.href = returnUrl + '?' + searchParams.toString();
                    }
                });
            }
        }
    }
}

customElements.define('submit-case', SubmitCase);